export default "__VITE_ASSET__BDNPC7dV__"